import myapi from '../../api/index.js'

export default {
  namespaced: true,
  state: {
    info: null,
    weixinInfo: null,
    weiboInfo: null
  },
  mutations: {
    // 刷新时获取user信息
    initUserInfo: state => {
      try {
        const data = JSON.parse(localStorage.getItem('user'))
        state.info = data
      } catch (e) {}
    },
    // 修改用户信息
    updateUserInfo: (state, data) => {
      state.info = data
      localStorage.setItem('user', JSON.stringify(data))
    },
    // 刷新时获取微信信息
    initWeixinInfo: state => {
      try {
        const data = JSON.parse(localStorage.getItem('weChat'))
        state.weixinInfo = data
      } catch (e) {}
    },
    // 修改微信信息
    updateWeixinInfo: (state, data) => {
      state.weixinInfo = data
      localStorage.setItem('weChat', JSON.stringify(data))
    },
    // 刷新时获取微博信息
    initWeiboInfo: state => {
      try {
        const data = JSON.parse(localStorage.getItem('weibo'))
        state.weiboInfo = data
      } catch (e) {}
    },
    // 修改微博信息
    updateWeiboInfo: (state, data) => {
      state.weiboInfo = data
      localStorage.setItem('weibo', JSON.stringify(data))
    }
  },
  actions: {
    send: (context, number) => {
      return myapi.send(number)
    },
    register: (context, info) => {
      return myapi.register(info)
    },
    login: (context, info) => {
      return myapi.login(info)
    }
  }
}
